// src/App.js
import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainPage from './pages/MainPage';
import Nav from './component/common/Nav';
import ChatbotContainer from './component/ui/ChatbotContainer';
import { LocationProvider } from './contexts/LocationContext'; 

function App() {
  const [showChatbot, setShowChatbot] = useState(false);

  const toggleChatbot = () => setShowChatbot(!showChatbot);
  const handleAIButtonClick = () => setShowChatbot(true);

  return (
    <LocationProvider> {/* ✅ 여기 감싸기 */}
      <div className="app-container">
        <Nav />
        <Routes>
          <Route 
            path="/" 
            element={<MainPage onAIButtonClick={handleAIButtonClick} />} 
          />
        </Routes>
        {showChatbot && <ChatbotContainer onClose={() => setShowChatbot(false)} />}
      </div>
    </LocationProvider>
  );
}

export default App;
